import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Button, Input, Typography } from "@material-tailwind/react";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { usePortalAuth } from "../context/PortalAuthContext";
import { portalApi } from "../services/portalApi";

export default function PortalAdminRevistaNuevo() {
  const { user, isAuthenticated } = usePortalAuth();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [saving, setSaving] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    const t = title.trim();
    if (!t) {
      toast.error("Indica un título");
      return;
    }
    setSaving(true);
    try {
      const r = await portalApi.adminRevistaCreateIssue({ title: t });
      const id = r?.issue?.issueId;
      if (!id) throw new Error("No se recibió el id del ejemplar");
      toast.success("Borrador guardado");
      navigate(`/admin/revistas/${id}`, { replace: true });
    } catch (err) {
      toast.error(err?.message || "No se pudo guardar");
    } finally {
      setSaving(false);
    }
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (user?.role !== "admin") return <Navigate to="/" replace />;

  return (
    <div className="mx-auto w-full max-w-lg">
      <div className="text-center mb-8">
        <Typography
          variant="h3"
          className="font-sans text-brand-dark text-2xl sm:text-3xl font-semibold tracking-tight"
        >
          Nuevo ejemplar
        </Typography>
        <p className="mt-2 text-brand-gray text-sm sm:text-base leading-relaxed">
          Guarda el título para crear el borrador; después podrás subir el PDF.
        </p>
      </div>

      <div className="flex justify-center mb-6">
        <Link
          to="/admin/revistas"
          className="inline-flex items-center gap-1 text-sm text-brand-lavender hover:underline"
        >
          <ChevronLeftIcon className="h-4 w-4" aria-hidden />
          Volver a revista
        </Link>
      </div>

      <form
        onSubmit={onSubmit}
        className="rounded-xl border border-brand-lavender/20 bg-white p-6 sm:p-8 space-y-5"
      >
        <Input
          label="Título del ejemplar"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
          autoFocus
        />
        <div className="flex flex-wrap justify-center gap-3">
          <Button
            type="submit"
            disabled={saving}
            className="bg-brand-lavender text-white normal-case"
          >
            {saving ? "Guardando…" : "Guardar y continuar"}
          </Button>
          <Link to="/admin/revistas">
            <Button type="button" variant="text" className="normal-case text-brand-gray">
              Cancelar
            </Button>
          </Link>
        </div>
      </form>
    </div>
  );
}
